<template>
  <div class="row">
    <div class="col-md-12">
        <div class="col-md-4 adBox" v-for="(slide, idx) of specialEditSlides" :key="idx" v-cloak :data-fake="(slide.Link)? slide.Link.LinkURL: ''"><a :href="getLink(slide)" :target="(slide.Link) ? (slide.Link.Blank ? '_blank' : '_self') : '' "><img :src="slide.ImageURL" :alt="slide.Title"/></a></div>
    </div>
  </div>
</template>

<script>
import home from './home.js'

export default {
  name: 'TopicBanners',
  props: ["specialEditSlides"],
  methods: {
    ...home
  },
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/TopicBanners.vue